import { useCallback } from 'react'

import { QuarterlyAnalytics } from 'commons/types/DTO/bank/alerts/quarterlyAnalytics'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'
import { Filter } from './components'

export const QuarterlyAnalyticsTable = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { quarterlyAnalyticsPage, quarterlyAnalyticsSize },
    showQuarterlyAnalytics,
    showQuarterlyAnalyticsTotalCount
  } = data

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'quarterlyAnalytics')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="Quarterly Analytics" anchor="qr">
      <Layer rounded shadowed stretch>
        <Filter />
        <Table<QuarterlyAnalytics>
          dataQa={TableDataQa.BP_ALERTS_QUARTERLY_ANALYTICS}
          columns={columns()}
          dataSource={showQuarterlyAnalytics.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('quarterlyAnalytics')}
          pagination={{
            page: quarterlyAnalyticsPage || 1,
            size: quarterlyAnalyticsSize || 10,
            onChange: handlePageChange,
            total: showQuarterlyAnalyticsTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
